import React, { useState } from 'react';
import { useLocation, useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AddEditQuickTapSession from '../../AddEditQuickTapSession/AddEditQuickTapSession';
import { Box, AppBar, Toolbar, Typography, Button, Paper } from '@mui/material';
import { Save, Cancel, ContentCopy } from '@mui/icons-material';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';
import LoadingBackdrop from '../../Common/LoadingBackdrop';
import { duplicateQuickTapSession } from '../../../actions/quickTapsActions';
import Swal from 'sweetalert2';

const QuickTapsAddEditPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const isEdit = location.pathname.includes('edit');
  const [isDuplicating, setIsDuplicating] = useState(false);

  const handleDuplicate = async () => {
    const { isConfirmed } = await Swal.fire({
      title: 'Duplicate Quick Tap?',
      text: 'This will create a copy of this quick tap (inactive by default).',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Duplicate',
    });
    if (!isConfirmed) return;

    try {
      setIsDuplicating(true);
      const newQuickTap = await dispatch(duplicateQuickTapSession(id));
      Swal.fire({
        icon: 'success',
        title: 'Quick Tap Duplicated!',
        text: `Created: ${newQuickTap.title}`,
        timer: 1500,
      }).then(() => {
        navigate(`/quick-taps/edit/${newQuickTap.id}`);
      });
    } catch (err) {
      console.error('Error duplicating quick tap:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to duplicate quick tap. Please try again.',
      });
    } finally {
      setIsDuplicating(false);
    }
  };

  return (
    <MainContentContainer sx={{ paddingBottom: 4 }}>
      <LoadingBackdrop open={isDuplicating} />
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? 'Edit Quick Tap Session' : 'Create New Quick Tap Session'}
          </Typography>
          {isEdit && (
            <Button
              color="info"
              onClick={handleDuplicate}
              startIcon={<ContentCopy />}
              variant="contained"
              sx={{ marginRight: 2 }}
              disabled={isDuplicating}
            >
              Duplicate
            </Button>
          )}
          <Button
            color="error"
            component={Link}
            to="/quick-taps"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            form="quick-tap-form"
            type="submit"
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditQuickTapSession
            isEdit={isEdit}
            selectedId={id}
          />
        </Paper>
      </Box>
    </MainContentContainer>
  );
};

export default QuickTapsAddEditPage;
